import React from 'react'
import Flex from 'typescript-styled-flex'
import { connect, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  FiChevronRight,
  FiCornerDownRight,
  FiCornerUpLeft,
  FiMail,
  FiPhone,
  FiUser,
} from 'react-icons/fi'
import {
  getEventById,
  getReservationCustomStatusColor,
} from '../../reducers/bookingCalendar/selectors/events'
import { Color } from '../ColorPalette'
import styled from '../../theme'
import { toggleUpdateReservationModal } from '../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import getNotificationServiceStore from '../../reducers/notificationService/getNotificationServiceStore'
import TemplateSendModal from '../../containers/BookingCalendar/ReservationModal/TemplateSendModal'
import openModal from '../../actions/Modals/openModal'
import { Modals } from '../../containers/Modals/ModalContainer'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'
import NestedNotificationHeader from './NestedNotificationHeader'

const Ellipsis = styled.div<IWithSize>`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: ${({ size }) => (size ? 225 * size : 225)}px;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    max-width: ${({ size }) => (size ? 196 * size : 196)}px;
  }
`

function ReservationInfo({
  reservationColor,
  event,
  reservation,
  openReservation,
  modalOpen,
  size = 1,
}) {
  const { t } = useTranslation()
  const service = useSelector(getNotificationServiceStore)

  function reservationEdit() {
    if (!service.accessToken && event && !event.isDeleted) {
      openReservation(String(reservation.reservationId))
    }
  }

  function sendEmail() {
    if (!service.accessToken) {
      modalOpen(
        Modals.TemplateSendModal,
        <TemplateSendModal email={reservation.email} event={event} />,
      )
    }
  }

  function call() {
    window.location.href = `tel:${reservation.phone}`
  }

  return (
    <Flex column={true} style={{ padding: `${18 * size}px` }}>
      <Flex row={true} alignCenter={true}>
        <Flex justifyCenter={true} alignStart={true}>
          <Color
            size={size}
            static={true}
            width={`${32 * size}px`}
            height={`${32 * size}px`}
            color={reservationColor}
            style={{
              margin: `0px ${20 * size}px`,
              marginLeft: '0px',
            }}
          ></Color>
        </Flex>
        <NestedNotificationHeader
          size={size}
          style={{ cursor: !event || event.isDeleted ? 'unset' : 'pointer' }}
          onClick={reservationEdit}
        >
          <Flex
            style={{ width: '100%', wordBreak: 'break-all' }}
            justifyBetween={true}
          >
            {`${t('BBO_930_reservation_no')} ${reservation.reservationId}`}
            <FiChevronRight size={`${14 * size}px`} />
          </Flex>
        </NestedNotificationHeader>
      </Flex>
      <Flex
        column={true}
        style={{
          fontSize: `${14 * size}px`,
          marginTop: `${15 * size}px`,
          paddingLeft: `${52 * size}px`,
        }}
      >
        {reservation.person && (
          <Ellipsis size={size}>
            <FiUser size={`${14 * size}px`} /> {reservation.person}
          </Ellipsis>
        )}
        {reservation.fromDate && (
          <Ellipsis size={size}>
            <FiCornerDownRight size={`${14 * size}px`} /> {reservation.fromDate}
          </Ellipsis>
        )}
        {reservation.toDate && (
          <Ellipsis size={size}>
            <FiCornerUpLeft size={`${14 * size}px`} /> {reservation.toDate}
          </Ellipsis>
        )}
        {reservation.phone && (
          <Ellipsis size={size} style={{ cursor: 'pointer' }} onClick={call}>
            <FiPhone size={`${14 * size}px`} /> {reservation.phone}
          </Ellipsis>
        )}
        {reservation.email && (
          <Ellipsis
            size={size}
            style={{ cursor: 'pointer' }}
            onClick={sendEmail}
          >
            <FiMail size={`${14 * size}px`} /> {reservation.email}{' '}
            <FiChevronRight size={`${14 * size}px`} />
          </Ellipsis>
        )}
      </Flex>
    </Flex>
  )
}

const mapStateToProps = (state, ownProps) => ({
  event: getEventById(ownProps.reservation.reservationId)(state),
  reservationColor: getReservationCustomStatusColor(
    ownProps.reservation.reservationId,
  )(state),
})

const mapDispatchToProps = dispatch => ({
  modalOpen: (id, element) => dispatch(openModal(id, element)),
  openReservation: id => dispatch(toggleUpdateReservationModal(id, true)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReservationInfo)
